import * as React from 'react'
import "./../../style/tech-stack-selection.module.css"
import {Select} from './../../components/elements'
import { emailHasCorrectFormat } from '../../utils';
import {Button} from './../elements'

type Props = {
    unnsupportedDrivers: any, 
    unsupportedPlugins: any,
    upsideEmit: (state:any) => void // shouldn't managed data by itself rather the parent component should do. upside emit just sends the data upwords
};

type State = {
 selectedDriver: string,
 selectedPlugin: string,
 error: boolean, 
 email: string,
 errorMessage: string[] | []
}

class TechStackSelection extends React.PureComponent<Props, State> {
    constructor (props: Props) {
        super(props);
        this.state = {
            selectedDriver: '',
            selectedPlugin: '',
            error: false,
            errorMessage: [],
            email: ''
        }
    }

    getSuperTokensDropdown = (dropDownFor:"unnsupportedDrivers" |  "unsupportedPlugins") => {
        const stateToUpdate = dropDownFor === 'unnsupportedDrivers' ? 'selectedDriver' : 'selectedPlugin'
        const valueToDisplay = dropDownFor === 'unnsupportedDrivers' ? this.state.selectedDriver : this.state.selectedPlugin
        const versionToSelect = Object.keys(this.props[dropDownFor]).map((element) => {
            return {
                id: element,
                displayName: this.props[dropDownFor][element]['displayName']
            }
        })
        return (
            <div
                className="select-main center-horizontally">
                <div
                    className="select-main-title font-weight-medium">
                    {dropDownFor === 'unnsupportedDrivers' ? 'Select frameWork' : 'Select Database'}
                </div>
                <Select
                onSelected={this.onSuperTokenCoreVersionChange}
                currentValue={valueToDisplay}
                options={versionToSelect}
                updateValueFor={stateToUpdate}
                styleClass={'background-white'}
                />
            </div>
        )
    }

    onEmailAddressChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        let value = event.target.value;
        this.setState({email: value})
    }

    getEmailAddressComponent = () => {
        return (
            <input
            onChange={this.onEmailAddressChange}
            type="text"
            placeholder="Your email address"
            value={this.state.email}
            name="signup-form-company-input"
            className="email-select">
        </input>
        )
    }

    getNotifyButton = () => {
        //TODO: analytics
        // pass in the props to button component
        return (
            <div className="button-margin-top">
                <Button 
                    onClick={this.onSubmit}
                    size={3}
                    text={'Notify me'}
                    textBold={true}
                    color={2}
                />
            </div>
        )
    }

    // validating data
    onSubmit = async () => {
        const errors = []
        this.setState({error: false, errorMessage: []})
        if (this.state.selectedDriver === '') {
            errors.push('Please Select Driver')
        } 
        if (this.state.selectedPlugin === '') {
            errors.push('Please Select Plugin')
        } 
        if (this.state.email === '') {
            errors.push('Please Select Email')
        } else if (!emailHasCorrectFormat(this.state.email)) {
            errors.push('Please enter valid email')
        }
        if (errors.length > 0) {
            this.setState({error: true, errorMessage: [...errors]})
            return 
        }
        await this.props.upsideEmit(this.state)
        return
    }

    onSuperTokenCoreVersionChange = (event: React.FormEvent<HTMLSelectElement>, dropDownFor:"selectedDriver" |  "selectedPlugin") => {
        const currenState = {...this.state}
        currenState[dropDownFor] = event.currentTarget.value
        this.setState({...currenState})
    }

    onSuperTokenDatabaseVersionChange = (event: React.FormEvent<HTMLSelectElement>) => {
        this.setState({selectedPlugin: event.currentTarget.value})
    }

    render () {
        return (
        <div className="tech-stack-selection-main center-horizontally">
            <div className="center-horizontally"> 
                <h3 className="text-center"> Please select your desired framework and database from the options below and 
    we will notify you on release.</h3>
                {this.getSuperTokensDropdown('unnsupportedDrivers')}
                {this.getSuperTokensDropdown('unsupportedPlugins')}
                {this.getEmailAddressComponent()}
                {this.getNotifyButton()}
            </div>
        </div>
        )
    }
}




export default TechStackSelection